import styled from "styled-components";
import { media } from "../../../config/helpers/queries/media";
export const StepWrapper = styled.div`
  width: 100%;
  font-size: 14px;

  ${media.desktop`
    padding: 0px 50px;
  `}

  .wrapp {
    padding: 10px;
    display: grid;
    ${"" /* grid-template-columns: repeat(auto-fit, minmax(600px, 1fr)); */}
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 20px;
    margin: auto;
  }

  .bottom {
    display: flex;
    justify-content: flex-end;
    align-content: center;
    margin-top: 90px;
    margin-bottom: 32px;
    ${media.desktop`
      margin-bottom: 0px; 
    `}

    & button {
      margin-right: 20px;
    }
  }

  .juridicalAddress {
    color: inherit;
    outline: 0;
    min-height: 48px;
    box-sizing: border-box;
    border: 1px solid rgba(211, 214, 224, 0.5);
    width: 100%;
    font-size: 14px;
    padding: 8px 26px 8px 12px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
  }

  @media (max-width: 500px) {
    .wrapp {
      grid-template-columns: 1fr;
    }
  }
`;
